import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const controller = customSetting.ServiceCenterController;
const getController = self.customSetting.getServiceCenter;
const postController = self.customSetting.postServiceCenter;

export default {
  // 2-7 教室/課程/課表管理
  getClassroom: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/GetRooms`)
        .then((res) => {
          context.commit("GET_CLASSROOM_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addClassroom: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/AddRoom`, data)
        .then((res) => {
          context.commit("GET_CLASSROOM_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  delClassroom: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/DelRoom`, data)
        .then((res) => {
          context.commit("GET_CLASSROOM_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updClassroom: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/updRoom`, data)
        .then((res) => {
          context.commit("GET_CLASSROOM_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  forSchedule: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/AddCourseInit`)
        .then((res) => {
          context.commit("FOR_SCHEDULE_USE", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getVendorList: (context, query) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/GetSupplier?word=${query}`)
        .then((res) => {
          context.commit("GET_SUPPLIER_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addSchedule: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/AddCourse`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getCourse: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/ViewCourseList`)
        .then((res) => {
          context.commit("GET_COURSE_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updScheduleMain: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/UpdCourseSchedule`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updScheduleStatus: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/UpdCourseStatus`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 2-8
  qryQualifyList: (context, { day1, day2 }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getController}/QryQualifyList?day1=${day1}&day2=${day2}`
        )
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  qryQualifyDetail: (
    context,
    { schedule_no, available_begin_date, class_date }
  ) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getController}/QryQualifyDetail?schedule_no=${schedule_no}&available_begin_date=${available_begin_date}&class_date=${class_date}`
        )
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  serviceCenterDownloadPdf: (context, file_id) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${baseApi}/${getController}/DownloadPdf?file_id=${file_id}`,
        method: "GET",
        responseType: "blob",
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  updQualifyDetail: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/UpdQualifyDetail`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  // 2-9
  updAttendStatus: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/UpdAttendStatus`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  updCardStatus: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/UpdCardStatus`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  // 2-10 異動申請審核
  getCardId: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryCardIdList`)
        .then((res) => {
          context.commit("GET_CARDID_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updCardIdStatus: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/UpdCardIdStatus`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 2-11 黑名單
  getBlacklist: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryBlackList`)
        .then((res) => {
          context.commit("GET_BLACKLIST_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addBlacklist: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/InsBlackList`, data)
        .then((res) => {
          context.commit("GET_BLACKLIST_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  delBlacklist: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/DelBlackList`, data)
        .then((res) => {
          context.commit("GET_BLACKLIST_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
